export const API_SERVER_IP = process.env.REACT_APP_API_SERVER_IP;
export const API_SERVER_PORT = process.env.REACT_APP_API_SERVER_PORT;

export const API_SERVER_FULL_URL =
  `${API_SERVER_IP}` + (API_SERVER_PORT ? `:${API_SERVER_PORT}` : "");
